var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 49,
    viewBox: "0 0 40 49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "b",
    d: "M20,48.66244c2.75787-.00789,4.9916-2.24162,4.99949-4.99949H15.00051c0,2.76114,2.23835,4.99949,4.99949,4.99949h0Zm15.00051-15.00051v-12.50897c0-7.67559-4.1013-14.10028-11.24987-15.79001v-1.69999C23.7022,1.59209,21.98417-.0474,19.91331,.00105c-2.00269,.04685-3.61505,1.65921-3.6619,3.6619v1.69999c-7.17728,1.69999-11.24987,8.10007-11.24987,15.79001v12.50897L0,38.66346v2.49974H40v-2.49974l-4.99949-5.00154Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.f75502f02db33e3e2b678a0e345adb0e.svg";
export { ForwardRef as ReactComponent };